var parent = require('../../es/array/from');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/features/array/from.js
// module id = 754
// module chunks = 3